import React, { useState, useEffect } from "react";
import axios from "axios";
import "./courseregform.css";
import Logo from "../logo/Manga_Cons _Logo2.png";

let courses;
export default function CourseREgForm({ info, loading, setLoading }) {
  const [selectedCourses, setSelectedCourses] = useState([]);
  //   const [studentId, setStudentId] = useState("");
  const studentId =
    info?.admission_number || info?.academicInfo?.admission_number;

  async function getCourses() {
    const params = {
      adm_number: studentId,
      pressent_level: info?.academicInfo.state.level,
      pressent_semester: info?.academicInfo.state.pressent_semester,
      pressent_session: info?.academicInfo.state.pressent_session,
    };
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/course_registration_form/getCourses`,
        { params },
      );
      courses = response?.data?.data;
      console.log(courses);
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getCourses();
  }, [info?.academicInfo.programme]); // ✅ Add dependency

  return (
    <div className="courseRegForm fx-cl space1">
      <div className="Form02Header fx-ac fx-jc space4">
        <figure>
          <img src={Logo} alt="logo" />
        </figure>
        <div className="fx-cl fx-jc">
          <h2>MANGA COLLEGE OF NURSING SCIENCES, ZURU</h2>
          <p>
            P.M.B. 02 Zuru-Kontagora Road Amanawa Area, Zuru, Kebbi State
            -Nigeria
          </p>
          <strong>Office of the Registrar</strong>
        </div>
      </div>
      <div className="invoice-second-container fx-jb space3">
        <div className="invoice-inner-div">
          <div className=" fx-cl space1">
            <h3>Course Registration Form</h3>
            <div className="fx-cl">
              <p>
                <strong>Name: </strong>
                {info?.personalInfo.first_Name +
                  " " +
                  info?.personalInfo.sur_Name +
                  " " +
                  info?.personalInfo.other_Name}
              </p>
              <p>
                <strong>Adm number:</strong>{" "}
                {info?.admission_number || info?.academicInfo?.admission_number}
              </p>
              <p>
                <strong>Programm:</strong>{" "}
                {info?.personalInfo.programme_of_study}
              </p>

              <p>
                <strong>Session:</strong>{" "}
                {info?.academicInfo.state.pressent_session}
              </p>
              <p>
                <strong>Level:</strong> {info?.academicInfo?.state.level}
              </p>
            </div>
          </div>
        </div>
        <div className="invoice-inner-div">
          <div className=" fx-cl space1">
            <div className="fx-cl">
              <p>
                <strong>State:</strong>{" "}
                {info?.personalInfo?.permanent_home_address.State_of_origin}
              </p>
              <p>
                <strong>Phone No.:</strong> +234
                {info?.contactInfo?.phone_number}
              </p>
              <p>
                <strong>Email:</strong> {info?.contactInfo?.email}
              </p>
            </div>
          </div>
        </div>
      </div>
      <table className="fx-cl spacem">
        <thead className="fx-cl spacem">
          <tr style={{ backgroundColor: "#1d2432", color: "#fff" }}>
            <th>S/N</th>
            <th>Course Code</th>
            <th>Course Title</th>
            <th>Course Unit</th>
            <th>Course Semester</th>
          </tr>
        </thead>
        <tbody className="fx-cl">
          {courses?.map((response, index) => {
            return (
              <tr key={response.courseCode}>
                <td>
                  <span>{index + 1}</span>
                </td>
                <td className=" fx-ac space2">
                  <span>{response.courseCode}</span>
                </td>
                <td style={{ textAlign: "left" }}>{response.courseTitle}</td>
                <td>{response.creditUnit}</td>
                <td style={{ textAlign: "left" }}>{response.semester}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ul style={{ listStyleType: "disc" }}>
        <em>Distribution:</em>
        <li>Head of Department</li>
        <li>Registrar</li>
        <li>Student's Copy</li>
      </ul>
      <button type="submit">Print</button>
    </div>
  );
}
